import moment from "moment";
import React, { useEffect, useState } from "react";
import {
  Content,
  Row,
  Col,
  Box,
  Button,
  Inputs,
  SimpleTable,
  Pagination,
} from "adminlte-2-react";
import _ from "lodash";
import controller from "./duck";
import { useSelector, useDispatch } from "react-redux";
import Tag from "../utils/Tag";
import { responseSelector } from "../utils/helpers/selectors";

const { Text } = Inputs;

function SuscripcionesByUsuario({ history, match }) {
  const dispatch = useDispatch();

  const modelSuscripciones = useSelector((state) => state.suscripcionesByUsuario);
  const modelDelete = useSelector((state) => state.deleteSuscripcion);

  const [suscripciones, setSuscripciones] = useState(null);
  const [totalResults, setTotalResults] = useState(0);
  const [activePage, setActivePage] = useState(0);
  const [pageSize, setPageSize] = useState(10);



  useEffect(() => {
    const data = modelDelete?.data?.data;
    const error = modelDelete?.error?.response?.data?.mensaje;

    if (error) {
      alert(error);
      dispatch(controller.deleteSuscripcionDuck.actions.clear());
    }
    if (data) {
      handlePage(0);
      dispatch(controller.deleteSuscripcionDuck.actions.clear());
    }
  }, [modelDelete]);

  useEffect(() => {
    const { data, error } = responseSelector(modelSuscripciones);


    if (error) {
      alert(error);
      dispatch(controller.suscripcionesByUsuarioDuck.actions.clear());
    }
    if (data) {
      setSuscripciones(data.items);
      setTotalResults(data.total);

      dispatch(controller.suscripcionesByUsuarioDuck.actions.clear());
    }
  }, [modelSuscripciones]);

  useEffect(() => {
    dispatch(controller.suscripcionesByUsuarioThunk(match.params.id, match.params.localId, 1, pageSize));
  }, []);

  function handlePage(page) {
    setActivePage(page);
    setSuscripciones([]);
    dispatch(controller.suscripcionesByUsuarioThunk(match.params.id, match.params.localId, page + 1, pageSize));
  }

  return (
    <Content
      title="Lista de suscripciones"
      subTitle="Lista de suscripciones"
      browserTitle="Lista de suscripciones"
      show={false}
    >
      <Row>
        <Col md="12">
          <Box title="Lista de suscripciones">
            <Col md="8"></Col>
            <Col md="12">
              <div style={{ marginTop: 15 }}>
                <Button
                  type="primary"
                  text="Agregar"
                  pullRight={true}
                  onClick={() => history.push(`/crearSuscripcion/${match.params.id}/${match.params.localId}`)}
                />
                <div>
                  <span>Total: {totalResults}</span>
                </div>
              </div>
            </Col>
            {suscripciones && suscripciones.length > 0 ? (
              <SimpleTable
              hover={true}
                data={suscripciones.map((row, index) => {
                  return {
                    nombre: row.description,
                    tipo: row.groupLabel.toUpperCase(),
                    cupos: row.ussage.capacity.left,
                    estado: row.estado,
                    vencimiento: moment(row.finalDate).format("DD-MM-YYYY"),
                    eliminar:(<Button
                      type="danger"
                      text="Eliminar"
                      onClick={() =>
                        dispatch(controller.deleteSuscripcionThunk({_id:row._id}))
                      }
                    />),
                  };
                })}
                columns={[
                  { title: "Plan", data: "nombre" },
                  { title: "Tipo de plan", data: "tipo" },
                  { title: "Reservas restantes", data: "cupos" },
                  { title: "Estado", data: "estado" },
                  { title: "Vencimiento", data: "vencimiento" },
                  { title: "Eliminar", data: "eliminar" },
                ]}
              />
            ) : (
              <Col md="12">
                <h4>No se han encontrado resutlados</h4>
              </Col>
            )}
            <Pagination
              activePage={activePage}
              pageSize={pageSize}
              totalElements={totalResults}
              onChange={handlePage}
              labels= {{
                first: 'Primera',
                last: 'Última',
                previous: 'Anterior',
                next: 'Siguiente',
              }}              
            />
            <div>
              <span>Total: {totalResults}</span>
            </div>
          </Box>
        </Col>
      </Row>
    </Content>
  );
}

export default SuscripcionesByUsuario;
